import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  MenuItem,
  AppBar,
  Toolbar,
  Grid,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel 
} from "@mui/material";
import api from "../services/api";
import { BackdropStyles, CircularProgressStyles } from "./genral"

export default function ShortlistDetailsForm() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    notice_period: "",
    current_salary: "",
    current_salary_currency: "",
    expected_salary: "",
    expected_salary_currency: "",
    visa_status: "",
    remarks: "",
    consent: false
  });
  const [implementerInfo, setImplementerInfo] = useState(null);
  const [dialogError, setDialogError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [resumeId, setResumeId] = useState(null);
  const [jdId, setJdId] = useState(null);
  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    message: "",
    type: "info"
    });

  const visaOptionsByCountry = {
    India: [
        "Indian Citizen",
        "OCI Card Holder",
        "Need Sponsorship"
    ],

    "United States": [
        "US Citizen",
        "Green Card",
        "H1B",
        "L1",
        "OPT",
        "Need Sponsorship"
    ],

    "United Kingdom": [
        "UK Citizen",
        "ILR",
        "Skilled Worker Visa",
        "Graduate Visa",
        "Need Sponsorship"
    ],

    Singapore: [
        "Singapore Citizen",
        "Permanent Resident (PR)",
        "Employment Pass (EP)",
        "S Pass",
        "Dependent Pass",
        "Need Sponsorship"
    ],

    Canada: [
        "Canadian Citizen",
        "PR",
        "Work Permit",
        "Study Permit",
        "Need Sponsorship"
    ],

    Australia: [
        "Australian Citizen",
        "PR",
        "482 Visa",
        "Working Holiday Visa",
        "Need Sponsorship"
    ]
    };

    const defaultVisaOptions = [
        "Citizen",
        "Permanent Resident",
        "Work Permit",
        "Dependent Visa",
        "Need Sponsorship"
    ];


    const getVisaOptions = (country) => {
        return visaOptionsByCountry[country] || defaultVisaOptions;
    };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const currencyOptions = (implementerInfo?.currencies || implementerInfo?.currency || "")
  .split(",")
  .map(c => c.trim())
  .filter(Boolean);

  useEffect(() => {
    if (!token) return;

    const resolveToken = async () => {
        try {
        const res = await api.get(`/resolve-token/${token}/`);
        setResumeId(res.data.resume_id);
        setJdId(res.data.jd_id);
        } catch {
        setDialog({
            open: true,
            title: "Invalid Link",
            message: "This link is invalid or has expired.",
            type: "error"
        });
        }
    };

    resolveToken();
    }, [token]);

    useEffect(() => {
    if (!resumeId || !jdId) return;

    const value = `${resumeId}_${jdId}`;

    api.get(`/shortlist-details/${value}/`)
        .then(res => {
        if (res.data.submitted) {
            navigate(`/shortlist-confirm/${value}`);
            return;
        }
        console.log("res.data", res.data)
        setImplementerInfo(res.data);
        })
        .catch(() => navigate("Invalid Link"));

    }, [resumeId, jdId]);


  const handleSubmit = () => {
    // if (
    //     !formData.current_salary ||
    //     !formData.expected_salary ||
    //     !formData.visa_status ||
    //     !formData.notice_period ||
    //     !formData.current_salary_currency ||
    //     !formData.expected_salary_currency
    // ) {
    //     setDialogError(
    //     <span style={{color: "#ff4d4d"}}>
    //         Please fill all the mandatory fields. indicated *
    //     </span>
    //     );
    //     return;
    // }

    if (!formData.consent) {
        setDialogError(
            <span style={{ color: "#ff4d4d" }}>
            Please provide consent to proceed.
            </span>
        );
        return;
    }

    setSubmitted(true);

    api.post("/submit-shortlist-details/", {
        token,
        ...formData,
        submitted_by: "candidate"
    })
    .then((response) => {
        if (response.data) {
        setDialogError(
            <span style={{color: "green"}}>
            Data submitted successfully
            </span>
        );

        setTimeout(() => {
            setRedirect(true);
            navigate(`/shortlist-confirm/${token}`);
        }, 2000);

        } else {
        setDialogError(
            <span style={{color: "#ff4d4d"}}>Data submission failed</span>
        );
        setSubmitted(false);
        }
    })
    .catch(() => {
        setDialogError(
        <span style={{color: "#ff4d4d"}}>Something went wrong</span>
        );
        setSubmitted(false);
    });
    };

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
        backdropFilter: "blur(10px)",
        background: "rgba(255,255,255,0.9)",
        borderBottom: "1px solid #eee",
        }}
    >
        <Toolbar>
        <Typography
            variant="h6"
            fontWeight={800}
            sx={{
            background: "linear-gradient(90deg,#6366f1,#ec4899)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            }}
        >
            ITConnectUS
        </Typography>
        </Toolbar>
    </AppBar>

      <Box display="flex" justifyContent="center" mt={6}>
        <Card sx={{ p: 4, maxWidth: 600, width: "100%" }}>
            <Typography variant="h5" gutterBottom>
            Hi {implementerInfo?.candidate_name || "Candidate"}, 
            thank you for your interest in the position of{" "}
            <strong>{implementerInfo?.job_title}</strong>.
            </Typography>

            <Typography variant="h6" gutterBottom>
            Additional Details Required
            </Typography>

          <TextField
            label="Notice Period (Days)"
            name="notice_period"
            fullWidth
            margin="normal"
            value={formData.notice_period}
            onChange={handleChange}
          />

          <Grid container spacing={2}>
            <Grid item xs={6}>
                <TextField
                label="Current Salary"
                name="current_salary"
                type="number"
                fullWidth
                value={formData.current_salary}
                onChange={handleChange}
                />
            </Grid>
    
            <Grid item xs={6}>
                <TextField
                select
                label="Currency"
                name="current_salary_currency"
                fullWidth
                value={formData.current_salary_currency}
                onChange={handleChange}
                >
                {currencyOptions.map((cur) => (
                    <MenuItem key={cur} value={cur}>
                    {cur}
                    </MenuItem>
                ))}
                </TextField>
            </Grid>
            </Grid>
            <br />
            <Grid container spacing={2}>
            <Grid item xs={6}>
                <TextField
                label="Expected Salary"
                name="expected_salary"
                type="number"
                fullWidth
                inputProps={{ maxLength: 14 }}
                value={formData.expected_salary}
                onChange={handleChange}
                />
            </Grid>
    
            <Grid item xs={6}>
                <TextField
                select
                label="Currency"
                name="expected_salary_currency"
                fullWidth
                value={formData.expected_salary_currency}
                onChange={handleChange}
                >
                {currencyOptions.map((cur) => (
                    <MenuItem key={cur} value={cur}>
                    {cur}
                    </MenuItem>
                ))}
                </TextField>
            </Grid>
            </Grid>

          {/* <TextField
            label={`Current Salary (${implementerInfo?.currency || ""}) *`}
            name="current_salary"
            type="number"
            fullWidth
            margin="normal"
            value={formData.current_salary}
            onChange={handleChange}
            />

            <TextField
            label={`Expected Salary (${implementerInfo?.currency || ""}) *`}
            name="expected_salary"
            type="number"
            fullWidth
            margin="normal"
            value={formData.expected_salary}
            onChange={handleChange}
            /> */}

            <TextField
            select
            name="visa_status"
            fullWidth
            margin="normal"
            value={formData.visa_status}
            onChange={handleChange}
            label="Visa Status *"
            >
            {getVisaOptions(implementerInfo?.country).map((option) => (
                <MenuItem key={option} value={option}>
                {option}
                </MenuItem>
            ))}
            </TextField>

            <TextField
                label="Remarks"
                name="remarks"
                multiline
                fullWidth
                rows={4}
                margin="normal"
                value={formData.remarks}
                onChange={handleChange}
            />

            <FormControlLabel
                control={
                    <Checkbox
                    checked={formData.consent}
                    onChange={(e) =>
                        setFormData({
                        ...formData,
                        consent: e.target.checked
                        })
                    }
                    />
                }
                label="I agree to share my profile with the client for this job opportunity."
            />

            <Grid item xs={12}>
                <div style={{ width: "100%" }}>
                {dialogError}
                </div>
            </Grid>

          <Grid item>
                {submitted ? (
                redirect ? null : (
                    <>
                    <Button variant="contained"
                    sx={{ textTransform: "none", mt: 3 }} size="small" disabled>
                        Submit & Continue
                    </Button>
                    <Backdrop open={true} sx={BackdropStyles()}>
                        <CircularProgress sx={{ ...CircularProgressStyles() }}/>
                    </Backdrop>
                    </>
                )
                ) : (
                <Button variant="contained"
                    sx={{ textTransform: "none", mt: 3 }} size="small" onClick={handleSubmit}>
                    Submit & Continue
                </Button>
                )}
            </Grid>
        </Card>
        <Dialog
        open={dialog.open}
        onClose={() => setDialog({ ...dialog, open: false })}
        >
        <DialogTitle sx={{ fontWeight: 700 }}>
            {dialog.title}
        </DialogTitle>

        <DialogContent>
            <Typography fontSize="14px">
            {dialog.message}
            </Typography>
        </DialogContent>

        <DialogActions>
            <Button
            variant="contained"
            onClick={() => setDialog({ ...dialog, open: false })}
            >
            OK
            </Button>
        </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}